import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild, ElementRef, Output } from '@angular/core';
import { User, AccountSubHeadDetails } from '../../shared/user.model';
import { Search } from '../../shared/user.model';
import { NgForm } from '@angular/forms';
//import { UserService } from '../../shared/user.service';
import { RegistrationService } from '../../registration.service';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { EventEmitter } from 'selenium-webdriver';

@Component({
  selector: 'app-subhead-grid',
  templateUrl: './subhead-grid.component.html',
  styleUrls: ['./subhead-grid.component.css']
})
export class SubheadGridComponent implements OnInit {

  maintitle="SubHead";
  title = "Account Sub Head List";
  AccountSubHeadDetails:any={};
  accountSubHeads:any={}; 
  itemsPerPage: number=5;
  currentPage: number=1;
  totalItems: number;
  isSearch:boolean;
  s: Search;
  constructor(private userService: RegistrationService, private route: ActivatedRoute, private router: Router, private errorHandler:ErrorHandler)  
  { 
    this.s=new Search();
    this.isSearch = false;
  }

  ngOnInit() {
    this.GetAllAccountSubHeads(this.itemsPerPage, 1);
  }

  pageChanged(pageNumber:number)
  {
    if (this.s.SearchText != "" && this.s.SearchText != null && this.s.SearchCriteria != "" && this.s.SearchCriteria != null)
    {
      this.isSearch = true;
    }
    else
    {
      this.isSearch = false;
    }
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNumber);
    else
    this.GetAllAccountSubHeads(this.itemsPerPage, pageNumber);
  }
  itemsPerPageChanged(itemsPerPage: number, pageNo: number) 
  {
    if (this.s.SearchText != "" && this.s.SearchText != null && this.s.SearchCriteria != "" && this.s.SearchCriteria != null)
    {
      this.isSearch = true;
    }
    else
    {
      this.isSearch = false;
    }
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNo);
    else
      this.GetAllAccountSubHeads(this.itemsPerPage, pageNo);
  }

  onSearch(s,itemsPerPage: number, pageNo: number) 
 {  
   var searchText = this.s.SearchText;
   var searchCriteria = this.s.SearchCriteria;
   if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
     swal("Warning!", "Please enter the search criteria and search text.", "warning");
   else {
     document.getElementById('loader-spinner').style.display = "block";
     this.userService.searchAccountSubHead(searchCriteria, searchText, itemsPerPage, pageNo)
       .subscribe(
         (data:any) => {
           this.accountSubHeads = data.AccountSubHeadPaginationModels;
           this.totalItems = data.TotalItemsCount;           
           this.currentPage = pageNo;
           document.getElementById('loader-spinner').style.display = "none";
         }, (error:any) => {
           document.getElementById('loader-spinner').style.display = "none";
           this.errorHandler.HandlerError(error);
         });
   }
 }

  GetAllAccountSubHeads(itemsPerPage: number, pageNo: number) {    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAllAccountSubHeads(itemsPerPage,pageNo)
      .subscribe(
        (data:any) => {
          this.accountSubHeads=data.AccountSubHeadPaginationModels;
          this.totalItems=data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;          
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  deleteAccountSubHead(accountHead:string, accountSubHead:string)
  {
    ;
      swal({
        title: 'Are you sure?',
        text: "You want to delete this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          document.getElementById('loader-spinner').style.display = "block";
          this.userService.deleteAccountSubHead(accountHead,accountSubHead).subscribe(
            (data:any) => {
              swal('','Account Sub Head Deleted!','success');
              this.GetAllAccountSubHeads(this.itemsPerPage, 1);
              this.s.SearchText = "";
            this.s.SearchCriteria = "";
            },(error) => {
              document.getElementById('loader-spinner').style.display="none";
              this.errorHandler.HandlerError(error);
            });
        }
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/finance/subhead-grid/subhead-grid.component.ts